import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowUpFromBracketRound = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 13.334a1 1 0 0 1 1 1v3.667h12v-3.667a1 1 0 1 1 2 0v4.667a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4.667a1 1 0 0 1 1-1Zm12.374-2.96a1 1 0 0 1-1.414 0L13 7.418v7.693a1 1 0 1 1-2 0v-7.7l-2.959 2.963A1 1 0 1 1 6.626 8.96l4.662-4.666a1 1 0 0 1 1.414-.001l4.672 4.667a1 1 0 0 1 0 1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowUpFromBracketRound);
export default Memo;
